var generateStyle = function generateStyle(componentTheme) {
  return {
    entryWrapper: {
      padding: "".concat(componentTheme.entryWrapperPadding, " 0"),
      width: '100%'
    },
    userResponse: {
      p: {
        margin: 0,
        paddingLeft: componentTheme.userResponsePaddingLeft,
        wordWrap: 'break-word'
      },
      'a[target=_blank]': {
        lineHeight: 0
      }
    },
    previewContainer: {
      height: '8rem',
      width: '8rem',
      border: "solid ".concat(componentTheme.previewBoxBorderWidth, " ").concat(componentTheme.previewBoxColor),
      color: componentTheme.fileIconColor,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    previewImg: {
      maxWidth: '100%',
      maxHeight: '100%',
      flex: '0 0 auto'
    },
    fileLinkWrapper: {
      display: 'flex'
    },
    fileLink: {
      flex: 1,
      textDecoration: 'none',
      color: 'inherit',
      cursor: 'pointer',
      '&:focus': {
        border: "1px solid ".concat(componentTheme.focusBorderColor),
        outline: "0.1875rem solid ".concat(componentTheme.focusOutlineColor),
        outlineOffset: '-0.1875rem',
        boxShadow: 'initial'
      }
    },
    removeButton: {
      marginLeft: componentTheme.removeButtonMargin
    },
    nameContainer: {
      minWidth: '10rem'
    },
    modalImage: {
      maxWidth: '100%'
    },
    spinner: {
      backgroundColor: componentTheme.spinnerColor
    }
  };
};
export default generateStyle;